import React from 'react';
import { deleteVoiceAsteriskDowngrade, } from '@Api';
import { IAbilities, IAuth, IOrganizationStore, } from '@Store';
import { CrudEnum, IPreviewVoiceAsteriskDowngrade, PermissionEnum, EnumTranslateTitle, TVoiceAsteriskDowngradeSortableListCol, } from 'atlas-shared';
import { tableColumnDatetimeSorter, tableColumnStringSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, listCloneButton, listDeleteButton, listEditButton, GetColumnSearchLikeProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const VoiceAsteriskDowngradeListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewVoiceAsteriskDowngrade) => React.ReactElement> = [], filters: IWithListProps<IPreviewVoiceAsteriskDowngrade, TVoiceAsteriskDowngradeSortableListCol>['filters'], sorter: IWithListProps<IPreviewVoiceAsteriskDowngrade, TVoiceAsteriskDowngradeSortableListCol>['sorter']): ColumnsType<IPreviewVoiceAsteriskDowngrade> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewVoiceAsteriskDowngrade, b: IPreviewVoiceAsteriskDowngrade) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    {
      title: t('TITLE'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a: IPreviewVoiceAsteriskDowngrade, b: IPreviewVoiceAsteriskDowngrade) => tableColumnStringSorter(a.title, b.title),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'title')?.order || null,
      filteredValue: filters.title || null,
      ...GetColumnSearchLikeProps(t, 'title', t('TITLE')),
      className: 'table-cell-title',
    },
    {
      title: t('STATUS'),
      dataIndex: 'status',
      key: 'status',
      render: (status: IPreviewVoiceAsteriskDowngrade['status'], voice_asterisk_downgrade: IPreviewVoiceAsteriskDowngrade) => EnumTranslateTitle('ASTERISK_STATUS', status, t),
      className: 'table-cell-status',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewVoiceAsteriskDowngrade['created_at'], voice_asterisk_downgrade: IPreviewVoiceAsteriskDowngrade) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewVoiceAsteriskDowngrade, b: IPreviewVoiceAsteriskDowngrade) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    showDeleted && { 
      title: t('DELETED'), 
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      className: 'table-cell-deleted_at',
      render: (deleted_at: IPreviewVoiceAsteriskDowngrade['deleted_at']) => deleted_at ? timeSince(t, new Date(deleted_at), true) : '',
      sorter: (a: IPreviewVoiceAsteriskDowngrade, b: IPreviewVoiceAsteriskDowngrade) => tableColumnDatetimeSorter(a.deleted_at, b.deleted_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'deleted_at')?.order || null,
    },
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewVoiceAsteriskDowngrade) => (
        <div className={'table-operation-wrp'}>
          {!row.deleted_at && buttons.map(button => button(row))}
          {abilities.can(null, CrudEnum.Insert, PermissionEnum.VoiceAsterisk, row) && listCloneButton(t, navigate, 'voice_asterisk_downgrade', row)}
          {abilities.can(null, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'voice_asterisk_downgrade', row)}
          {!row.deleted_at && abilities.can(null, CrudEnum.Update, PermissionEnum.VoiceAsterisk, row) && listEditButton(t, navigate, 'voice_asterisk_downgrade', row)}
          {!row.deleted_at && abilities.can(null, CrudEnum.Delete, PermissionEnum.VoiceAsterisk, row) && listDeleteButton(t, row, deleteVoiceAsteriskDowngrade)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewVoiceAsteriskDowngrade>;

};
